import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';

@Module({ namespaced: true })
export default class Auth extends VuexModule {
  currentAsset: any = null;

  @Mutation
  SET_CURRENT_ASSET(asset: any) {
    this.currentAsset = asset;
  }

  @Mutation
  UNSET_CURRENT_ASSET() {
    this.currentAsset = null;
  }

  get currentAssetReference() {
    return this.currentAsset ? this.currentAsset.reference : null;
  }

  @Action
  async FETCH_CURRENT_ASSET(payload: { reference: string }) {
    console.info('FETCH_CURRENT_ASSET', payload);
    this.context.commit('SET_CURRENT_ASSET', payload);
  }
}
